import { render, staticRenderFns } from "./ClassroomDetailTabMessage.vue?vue&type=template&id=43e406e4&scoped=true"
import script from "./ClassroomDetailTabMessage.vue?vue&type=script&lang=js"
export * from "./ClassroomDetailTabMessage.vue?vue&type=script&lang=js"
import style0 from "./ClassroomDetailTabMessage.vue?vue&type=style&index=0&id=43e406e4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e406e4",
  null
  
)

export default component.exports